// ----- BASE -----
var Base = {
	// properties
	remember_me: false, // Whether to remember the user using browser cookies.

	// methods
	addErrorCheckbox: function(obj_field, error_message) {
		obj_field
			.closest('.mb-3')
			.append('<div class="invalid-feedback">' + error_message + '</div>')
			.addClass('has-error');

		return this;
	},
	addErrorRow: function(obj, class_name, error_message) {
		console.debug('called', arguments.callee.name, class_name, error_message);

		const obj_class = obj.find('tr.' + class_name);
		// console.log(class_name, obj_class);

		obj_class.find('td input.form-control').addClass('is-invalid');
		obj_class.find('td select.form-control').addClass('is-invalid');

		return this;
	},
	addErrorSelectText: function(obj_field, error_message) {
		const obj_classname = obj_field.attr('class');

		if (typeof obj_classname !== 'undefined') {
			if (obj_classname.match(/date-selector/g)) {
				obj_field.parent().find('.date-selector.input').addClass('is-invalid').closest('.mb-3').addClass('has-error');
				obj_field.parent().append('<div class="invalid-feedback">' + error_message + '</div>');
			} else {
				obj_field.addClass('is-invalid').closest('.mb-3').addClass('has-error');
				obj_field.after('<div class="invalid-feedback">' + error_message + '</div>');
			}
		}

		return this;
	},
	addErrors: function(errors, obj) {
		console.debug('called', arguments.callee.name, errors, obj);

		if (typeof obj !== 'object') {
			obj = this.obj_form;
		}

		if (typeof errors === 'undefined' || errors === null) {
			console.error('errors is undefined or null');

			return this;
		}

		if (Object.keys(errors).length === 0) {
			console.log('object.keys(error).length is not greater than zero.');

			obj.find('.invalid-feedback').hide();

			return this;
		}

		// Go through all of error fields and add an invalid class to make it red.
		$.each(errors, (field_name, error_message) => {
			console.log({ field_name, error_message });

			const obj_field = obj.find('[name="' + field_name + '"]');
			const obj_length = obj_field.length;
			// const obj_type = typeof obj_field;
			// console.log(field_name, error_message, obj_field, obj_length, obj_type);

			if (typeof obj_length === 'number' && obj_length > 1) {
				switch (obj_field.attr('type')) {
					case 'checkbox':
					case 'radio':
						this.addErrorCheckbox(obj_field, error_message);
						break;

					default:
						this.addErrorSelectText(obj_field, error_message);
				}
			} else if (field_name === 'uploads') {
				obj.find('.uploads').addClass('is-invalid');
				obj.find('.uploads').after('<div class="invalid-feedback">' + error_message + '</div>');
			} else {
				const attr_type = obj_field.attr('type');
				console.log({ field_name, attr_type });

				// --- TRY HTML --- Look for an HTML class with the error name. 2020-07-29 20:23:04
				const obj_class = obj.find('tr.' + field_name);

				// console.log({ field_name, attr_type, obj_class });

				switch (attr_type) {
					case 'checkbox':
					case 'radio':
						this.addErrorCheckbox(obj_field, error_message);
						break;

					default:
						if (obj_class.length > 0) {
							this.addErrorRow(obj, field_name, error_message);
						} else {
							this.addErrorSelectText(obj_field, error_message);
						}
				}
			}
		});

		obj.find('.invalid-feedback').show();

		return this;
	},
	clearCursorWait: function() {
		document.body.style.cursor = 'default';

		$('.loading').hide();

		return this;
	},
	clearErrors: function(obj) {
		console.debug('called', arguments.callee.name);

		if (typeof obj !== 'object') {
			obj = this.obj_form;
		}

		obj.find('.is-invalid, .is-valid, .has-error').removeClass('is-invalid is-valid has-error').closest('div.mb-3').removeClass('has-invalid has-error');

		obj.find('.invalid-feedback, .valid-feedback').remove();

		return this;
	},
	clearMessage: function(selector) {
		console.debug('called', arguments.callee.name);

		selector = typeof selector !== 'undefined' ? selector : '#message, .message';

		$(selector).empty().removeClass('alert alert-danger alert-info alert-success alert-warning alert-dismissible');

		return this;
	},
	getFirstProp: function(obj) {
		for (let prop_name in obj) {
			if (prop_name !== 'uploads') {
				return prop_name;
			}
		}
	},
	getItem: function(key) {
		console.log(arguments.callee.name, key);

		return localStorage.getItem(key);
	},
	highlight: function(value, search) {
		const regex = new RegExp('(' + search + ')', 'gi');

		if (value !== null) {
			return value.replace(regex, '<mark>$1</mark>');
		}

		return value;
	},
	init: function() {
		console.debug('called', arguments.callee.name);

		if (typeof window.remote_api_url === 'string') {
			this.remote_api_url = window.remote_api_url;
		}

		this.remember_me = localStorage.getItem('remember_me') ? true : false;

		if (typeof this.initSection === 'function') {
			this.initSection();
		}

		if (typeof this.setEventHandlers == 'function') {
			this.setEventHandlers();
		}

		if (typeof this.setEventHandlersDebug == 'function') {
			this.setEventHandlersDebug();
		}

		if (typeof this.setKeyPress == 'function') {
			this.setKeyPress();
		}

		if (typeof this.initPost === 'function') {
			this.initPost();
		}

		return this;
	},
	isNumeric: function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	},
	removeItem: function(key) {
		localStorage.removeItem(key);

		return this;
	},
	setCursorWait: function() {
		document.body.style.cursor = 'wait';

		$('.loading').show();

		return this;
	},
	setItem: function(key, value) {
		console.log(arguments.callee.name, key, value);

		localStorage.setItem(key, value);

		return this;
	},
	setKeyPress: function(v) {
		console.log(arguments.callee.name, v);

		$(document).off('keydown').on('keydown', (e) => {
			const tag = e.target.tagName.toLowerCase();

			if ((e.key === 'Enter' && tag !== 'textarea') || ((e.metaKey || e.ctrlKey) && e.key === 'Enter')) {
				e.preventDefault();

				switch (v) {
					case 'contact':
						this.submitForm();
						break;

					case 'forgot':
						this.forgotPassword();
						break;

					case 'login':
						this.submitLogin();
						break;

					case 'request':
						this.submitRequest();
						break;

					case 'reset_password':
						this.submitResetPassword();
						break;

					case 'searchClaims':
						this.searchClaims();
						break;

					default:
				}
			} else if (e.key === 'Escape') {
				e.preventDefault();

				switch (v) {
					case 'searchClaims':
						this.clearClaims();
						break;

					default:
				}
			}
		});

		return this;
	},
	writeMessage: function(options, selector) {
		selector = typeof selector !== 'undefined' ? selector : '#message, .message';

		let message = (typeof options.message !== 'undefined' && options.message !== null) ? options.message : 'Unknown';

		let status = 'error';
		if (typeof options.status !== 'undefined') {
			status = options.status;
		} else if (typeof options.type !== 'undefined') {
			status = options.type;
		}

		if (typeof options.selector === 'object' && options.selector !== null) {
			selector = options.selector;
		}

		let icon;
		switch (status) {
			case 'danger':
			case 'error':
				icon = 'exclamation';
				status = 'danger';
				break;

			case 'info':
				icon = 'info-circle';
				break;

			case 'success':
				icon = 'check';
				break;

			case 'warning':
				icon = 'exclamation-triangle';
				break;

			default:
				icon = 'check';
		}

		this.clearMessage(selector);

		// --- Replace ticks with strong ---
		if (typeof message === 'string') {
			message = message.replace(/`(.+?)`/g, '<strong>$1</strong>');
		}

		$(selector)
			.html('<button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button><i class="fas fa-' + icon + '"></i> ' + message)
			.addClass('alert alert-' + status + ' alert-dismissible');

		return this;
	}
};
